// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@awc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

creditCardDetailsEntryStyles.securityCodeTokenExFrame = {
    labelProps: {
        css: css`
            display: flex;
            column-gap: 8px;
            ${StyledButton} ${TypographyStyle} {
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
            }
        `,
    },
};
creditCardDetailsEntryStyles.expirationDateLabel = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    weight: fontConfig.weight.medium,
    css: css`
        margin-bottom: 4px;
        display: block;
    `,
};
creditCardDetailsEntryStyles.expirationDateGridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
    `,
};
creditCardDetailsEntryStyles.cardNumberText = {
    css: css`
        font-size: ${fontConfig.fontSize.small};
    `,
};
creditCardDetailsEntryStyles.securityCodeText = {
    css: css`
        font-size: ${fontConfig.fontSize.small};
    `,
};
